import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { OrderDocumentService } from '@my-account/feature';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { FileDownloadService, IconModule } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sd-document-download-button',
  templateUrl: './document-download-button.component.html',
  styleUrls: ['./document-download-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule, SdvorButtonComponent],
})
export class DocumentDownloadButtonComponent implements OnDestroy {
  subscription = new Subscription();

  @Input() id: string;

  constructor(
    private orderDocumentService: OrderDocumentService,
    private fileDownloadService: FileDownloadService,
  ) {}

  download(): void {
    this.subscription.add(
      this.orderDocumentService
        .download(this.id)
        .pipe(take(1))
        .subscribe((response) => {
          if (!response || !response.body) {
            return;
          }

          const url = URL.createObjectURL(response.body);
          const fileName = this.formatFileName(response.headers.get('content-disposition'));

          this.fileDownloadService.download(url, fileName);
        }),
    );
  }

  formatFileName(value: string | null): string {
    try {
      return value.split(';')[1].split('=')[1].replace(/"/g, '');
    } catch {
      return `invoice_${this.id}.pdf`;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
